export default {
  onboarding: {
    actions: {
      mainBlue: 'Start'
    }
  },
  details: {
    stepTitle: 'Claim information',
    aboutProperty: 'Additional information',
    title: 'Details of damaged property:',
    errorMsgInputTxt: 'Mandatory field',
    errorMsgGeneral: 'Please check the form before continuing',
    errorImages: 'Please add photos before continuing',
    warningMsg: 'If this information is incomplete or incorrect, please contact your usual Allianz contact.',
    address: {
      literal: 'Address',
      placeholder: 'Enter a location'
    },
    zipCode: {
      literal: 'Postcode'
    },
    propertyType: {
      literal: 'Property type',
      options: {
        appartment: 'Flat',
        maison: 'House',
        local_commercial: 'Business premises'
      }
    },
    residentType: {
      literal: 'Type of resident',
      options: {
        propietarie: 'Owner',
        locataire: 'Tenant',
        propietarie_non_occupant: 'Owner Non Occupant'
      }
    },
    moreThanTwoYears: {
      literal: 'Age of the building',
      options: {
        less: 'Less than 2 years',
        more: 'More than 2 years'
      }
    },
    observations: {
      literal: 'Comments'
    },
    map: {
      empty: {
        title: 'No address',
        text: 'Please enter a valid address'
      }
    },
    textArea: {
      placeHolder: 'Text length limited to 255 characters maximum'
    }
  },
  closing: {
    actions: {
      mobilierButton: 'Continue with furniture damage'
    }
  },
  compensationType: {
    title: 'Which property damage solution do you prefer?',
    subtitle: 'About your property damage ',
    propertyDamage: 'Declared property damage',
    text: 'To do this, we offer three possible solutions:',
    recommended: 'Our recommendation!',
    amount: 'Amount reimbursed:',
    e2eCompensations: {
      ourRecommendation: 'Our recommendation',
      gagDetail: {
        title: 'Do the work myself',
        text: 'By opting for this solution, you will receive the immediate compensation below, enabling you to carry out the work independently and restore your property to its original condition.',
        link: 'Choose this solution'
      },
      billma: {
        title: 'Choosing my own artisan',
        text: 'Enclose the estimate from the craftsman of your choice to receive your compensation.',
        link: 'Choose this solution'
      },
      renDetail: {
        title: 'Choosing an Allianz-certified craftsman',
        text: 'Let us know your availability and we\'ll arrange for an Allianz-approved partner to come and repair your damage. You\'ll benefit from quality repairs with no administrative formalities. You\'ll only have to pay the deductible.',
        link: 'Choose this solution'
      }
    }
  },
  compensationMobilier: {
    title: 'Regarding your property damage',
    subtitle: 'Amount of compensation',
    total: 'Total:',
    totalAmount: 'Total compensation',
    actions: {
      primary: 'Yes, I accept the proposed compensation',
      secondary: 'I want to speak with an advisor'
    }
  }
}
